import { useRef, useState } from "react";
import { Camera, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function KioskReceiptButton({ contestId, storeId, accent, onPlayed }) {
  const [open, setOpen] = useState(false);
  const [phone, setPhone] = useState("");
  const [file, setFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);
  const send = async () => {
    if (!file) return toast.error("Scatta la foto dello scontrino");
    if (phone.replace(/\D/g, "").length < 9) return toast.error("Inserisci il tuo numero di telefono");
    setBusy(true);
    try {
      const res = await api.receiptOcrKioskUpload(contestId, file, phone, storeId);
      if (!res.play) { toast.error(`Scontrino non valido: ${res.receipt?.reason || ""}`, { duration: 8000 }); return; }
      setOpen(false); setFile(null); setPhone("");
      onPlayed(res.play);
    } catch (e) { toast.error(e?.response?.data?.detail || "Caricamento non riuscito"); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-5 py-2.5 text-sm font-semibold hover:bg-white/20 transition-colors" data-testid="kiosk-receipt-button">
        <Camera className="h-4 w-4" /> Partecipa con lo scontrino
      </button>
      {open && (
        <div className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-sm grid place-items-center p-4" data-testid="kiosk-receipt-dialog">
          <div className="w-full max-w-md rounded-2xl bg-white text-slate-900 p-6 space-y-4 shadow-2xl">
            <div className="flex items-start justify-between"><h3 className="font-display font-bold text-xl">Scontrino: fotografa e gioca</h3><button type="button" onClick={() => setOpen(false)} className="text-slate-500 hover:text-slate-900" data-testid="kiosk-receipt-close"><X className="h-5 w-5" /></button></div>
            <input ref={inputRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={(e) => setFile(e.target.files?.[0] || null)} data-testid="kiosk-receipt-file" />
            <button type="button" onClick={() => inputRef.current?.click()} className="w-full rounded-xl border-2 border-dashed p-6 grid place-items-center gap-1 text-sm font-semibold" style={{ borderColor: accent, color: accent, background: "#e8f1fd" }} data-testid="kiosk-receipt-pick">
              <Camera className="h-8 w-8" />{file ? `Foto pronta: ${file.name}` : "Apri la fotocamera"}
            </button>
            <label className="block text-sm font-bold">Il tuo numero di telefono <span className="text-red-600">*</span>
              <input value={phone} onChange={(e) => setPhone(e.target.value)} inputMode="tel" placeholder="+39 333 1234567" required className="mt-1 w-full rounded-lg border border-sky-300 bg-[#e8f1fd] px-3 py-2 text-base font-mono-code" data-testid="kiosk-receipt-phone" />
            </label>
            <p className="text-xs text-slate-600">Riceverai la ricevuta su WhatsApp e parteciperai all'estrazione finale. Verifichiamo lo scontrino in pochi secondi e giochi subito.</p>
            <button type="button" disabled={busy} onClick={send} className="w-full rounded-full py-3 font-bold text-white disabled:opacity-60 inline-flex items-center justify-center gap-2" style={{ background: accent }} data-testid="kiosk-receipt-submit">{busy ? <><Loader2 className="h-4 w-4 animate-spin" /> Verifica in corso…</> : "Verifica e gioca"}</button>
          </div>
        </div>
      )}
    </>
  );
}
